import React from "react";

const Button = ({ text, className, link, func }) => {
  return (
    <a
      href={link}
      className={`px-10 py-3.5 w-full text-center rounded-md shadow-md block sm:w-auto duration-300 cursor-pointer text-gray-500 hover:text-indigo-600 ${className}`}
      onClick={func}
    >
      {text}
    </a>
  );
};

export default Button;
